/* IM Quick View – logique (image, titre, prix, tailles, flocage, CTA) */
(() => {
  /* log retiré (prod) */

  const root = document.getElementById('im-qv');
  if (!root) return;

  // --- DOM refs
  const title        = root.querySelector('#im-qv-title');
  const priceNode    = root.querySelector('#im-qv-price');
  const thumb        = root.querySelector('#im-qv-thumb');
  const form         = root.querySelector('#im-qv-form');
  const optBox       = root.querySelector('#im-qv-options');
  const varId        = root.querySelector('#im-qv-variant-id');
  const btnAdd       = root.querySelector('.im-qv__submit');
  const sizeCurrent  = root.querySelector('#im-qv-size-current');
  const sizesHead    = root.querySelector('.im-qv__sizes-head');
  const liveCount    = root.querySelector('#im-qv-livecount');

  // Flocage
  const flocageToggle = root.querySelector('#im-qv-flocage');
  const flocageFields = root.querySelector('#im-qv-flocage-fields');
  const numeroInput   = root.querySelector('input[name="properties[Numéro]"]');
  const numeroHint    = root.querySelector('.im-qv__hint');
  const nomInput      = root.querySelector('input[name="properties[Nom]"]');
  const subInput      = root.querySelector('input[name="properties[Sous le numéro]"]');
  const qvJName       = root.querySelector('[data-im-qv-name]');
  const qvJNumber     = root.querySelector('[data-im-qv-number]');
  const qvJSub        = root.querySelector('[data-im-qv-sub]');

  // --- State
  let product = null;
  let currentVariant = null;
  let selections = {}; // { 'Taille': 'S', ... }
  let isOpen = false;
  const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

  // --- Utils
  const money = (cents) => {
    try {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: cur
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
    }
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Produit introuvable');
    return res.json();
  };

  // Nombre "personnes consultent ce produit" réaliste et différent par produit.
  const getLiveCountFromSeed = (seed) => {
    if (!seed) return 12;
    let hash = 0;
    for (let i = 0; i < seed.length; i += 1) {
      hash = ((hash << 5) - hash) + seed.charCodeAt(i);
      hash |= 0;
    }

    const min = 5;
    const max = 18;
    const base = min + (Math.abs(hash) % (max - min + 1));
    const dayBucket = Math.floor(Date.now() / 86400000);
    const drift = ((Math.abs(hash + dayBucket) % 3) - 1); // -1, 0, +1

    return Math.max(min, Math.min(max, base + drift));
  };

  const getLiveCountForProduct = (p) => {
    if (!p) return 12;
    return getLiveCountFromSeed(`${p.id || ''}-${p.handle || ''}-${p.title || ''}`);
  };

  // 22/10 lot 3 : clavier — focus mis dans la fenêtre, page derrière inerte, focus rendu au bouton d'origine
  const sheet    = root.querySelector('.im-qv__sheet');
  const closeBtn = root.querySelector('.im-qv__close');
  let lastTrigger = null;
  let openedByKeyboard = false;
  let inertEls = [];
  const setPageInert = (on) => {
    if (!on) {
      inertEls.forEach((el) => { el.inert = false; });
      inertEls = [];
      return;
    }
    const pc = document.querySelector('.page-container');
    if (!pc) return;
    // La fenêtre e-mail (#grinta-popup, au-dessus de tout) vit dans le pied de page : si elle s'ouvre
    // pendant l'ajout rapide, elle doit rester utilisable → sa section n'est jamais rendue inerte.
    inertEls = Array.from(pc.children).filter((el) => !el.inert && !el.querySelector('#grinta-popup'));
    inertEls.forEach((el) => { el.inert = true; });
  };

  // --- Open / Close (sans empilement de listeners)
  let closeTimer = null; // click-fix 29/08 : timer robuste (transitionend peut ne jamais tirer)
  const open = (kb) => {
    if (isOpen) return;
    isOpen = true;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    // Audit 27/10 (ACH10) : filet de sécurité. Le CSS (2147483599, im-quickview.liquid) passe déjà au-dessus
    // de la bannière cookies Shopify tant qu'elle reste sous la fenêtre e-mail (constaté). Si la bannière
    // affichée monte un jour plus haut, on prend le maximum : #im-cart, rendu APRÈS #im-qv dans le layout,
    // reste devant à z-index égal. Sinon on rend la main au CSS (style inline vidé).
    const pcBanner = document.getElementById('shopify-pc__banner');
    const pcZ = (pcBanner && pcBanner.getClientRects().length) ? parseInt(getComputedStyle(pcBanner).zIndex, 10) : 0;
    root.style.zIndex = pcZ >= 2147483599 ? '2147483647' : '';
    root.style.display = 'block';
    // force reflow pour activer la transition CSS
    // eslint-disable-next-line no-unused-expressions
    root.offsetHeight;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    // 22/10 lot 3 : ouverte au clavier → focus sur le bouton Fermer (contour visible) ; preventScroll : la page ne bouge pas.
    // Au toucher : focus laissé tel quel (comme avant) — un focus dans la feuille ferait disparaître la barre
    // des paliers (im-tier-bar, écouteur focusin) jusqu'au prochain défilement vers le haut (relecture 22/10).
    lastTrigger = document.activeElement;
    openedByKeyboard = !!kb;
    if (openedByKeyboard && closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (_) {} }
    setPageInert(true);
  };

  // Relecture 03/11 : retour arrière instantané (page gardée en mémoire) → l'ajout rapide ne reste pas ouvert
  window.addEventListener('pageshow', (e) => { if (e.persisted) close(); });

  const close = () => {
    if (!isOpen) return;
    isOpen = false;
    // 22/10 lot 3 : page réactivée, puis focus sorti de la fenêtre AVANT aria-hidden.
    // Rendu au bouton d'origine seulement si la fenêtre a été ouverte au clavier (pas de contour au toucher).
    setPageInert(false);
    const back = lastTrigger;
    lastTrigger = null;
    const act = document.activeElement;
    if (!act || act === document.body || root.contains(act)) {
      if (openedByKeyboard && back && back !== document.body && back.isConnected && !root.contains(back) && typeof back.focus === 'function') {
        try { back.focus({ preventScroll: true }); } catch (_) {}
      }
      if (root.contains(document.activeElement)) document.activeElement.blur();
    }
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      closeTimer = null;
      if (!isOpen) root.style.display = 'none';
    }, 450); /* click-fix 29/08 : remplace transitionend (jamais garanti) — même délai que la transition, aucun rendu changé */
  };

  // Fermer : scrim / bouton / ESC
  root.addEventListener('click', (e) => {
    if (e.target.closest('.im-qv__scrim,[data-im-qv-close]')) {
      e.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (isOpen && e.key === 'Escape') close();
    // 22/10 lot 3 : Tab / Maj+Tab tournent dans la fenêtre (l'en-tête et la capsule, hors page, restent derrière le voile)
    if (!isOpen || e.key !== 'Tab' || !sheet) return;
    const a = document.activeElement;
    // Focus dans une autre fenêtre ouverte par-dessus (fenêtre e-mail, bannière cookies) : elle gère son propre Tab
    if (a && a !== document.body && !root.contains(a) && a.closest('#grinta-popup, [role="dialog"], [aria-modal="true"], [id^="shopify-pc__"]')) return;
    const f = Array.from(sheet.querySelectorAll('button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'))
      .filter((el) => !el.disabled && el.getClientRects().length);
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (!sheet.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && (a === first || a === sheet)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });
  // 22/10 lot 3 : passage à ≥ 992 px fenêtre ouverte (tablette tournée) : le CSS la masque → on la ferme
  // vraiment, sinon la page resterait inerte et bloquée en défilement.
  const mqDesk = window.matchMedia('(min-width: 992px)');
  const onDesk = () => { if (mqDesk.matches && isOpen) close(); };
  if (mqDesk.addEventListener) mqDesk.addEventListener('change', onDesk);
  else if (mqDesk.addListener) mqDesk.addListener(onDesk);

  // --- Variants
  const setVariantBySelections = () => {
    if (!product) return;
    const v = product.variants.find((variant) =>
      product.options.every((opt, i) => {
        const wanted = selections[opt.name] ?? variant[`option${i + 1}`];
        return variant[`option${i + 1}`] === wanted;
      })
    ) || product.variants[0];

    currentVariant = v;
    if (varId) varId.value = v.id;
    if (priceNode) priceNode.textContent = money(v.price);
    if (btnAdd) btnAdd.disabled = !v.available;
    // Produits multi-couleurs : la vignette suit la couleur choisie (variantes maillots : featured_image null → no-op)
    // Perf 11/09 : v.featured_image.src est le fichier MAÎTRE non redimensionné (~50 Ko,
    // mesuré) pour un cadre affiché à 90x90px (besoin réel ~4,7 Ko) — theme.Images est déjà
    // chargé (theme.js) au moment où l'utilisateur choisit vraiment une couleur.
    if (thumb && v.featured_image && v.featured_image.src) {
      const thumbImg = thumb.querySelector('img');
      if (thumbImg) {
        const sized = (window.theme && theme.Images && theme.Images.getSizedImageUrl)
          ? theme.Images.getSizedImageUrl(v.featured_image.src, '180x')
          : v.featured_image.src;
        thumbImg.src = sized;
      }
    }

    const sizeOpt = product.options.find((o) => /size|taille/i.test(o.name));
    if (sizeCurrent) {
      if (sizeOpt) {
        const idx = product.options.indexOf(sizeOpt);
        sizeCurrent.textContent = v[`option${idx + 1}`] || '—';
      } else {
        sizeCurrent.textContent = '—';
      }
    }
    // Fix 16/09 : "Taille : —" s'affichait même sur un produit sans option de taille
    // (ex. Pack Duo, une seule variante "Default Title") — le titre "Taille" n'a de sens
    // que si une vraie option taille existe sur le produit. im-mobile-popup.css force déjà
    // "display:flex !important" sur cet élément (règle #im-qv .im-qv__sizes-head) : un style
    // inline sans !important ne peut pas le battre, il faut passer par setProperty(...,
    // 'important') pour que l'inline gagne à son tour (même piège que le CSS "critique" du
    // panier hier soir, réglé cette fois côté JS plutôt qu'en changeant la CSS existante).
    if (sizesHead) {
      if (sizeOpt) sizesHead.style.removeProperty('display');
      else sizesHead.style.setProperty('display', 'none', 'important');
    }
  };

  const renderOptions = () => {
    if (!optBox) return;
    optBox.innerHTML = '';
    selections = {};

    // Fix 16/09 : un produit sans vraies options (une seule variante) a une option
    // "Title"/valeur "Default Title" imposée par Shopify — jamais utile à afficher
    // (ex. Pack Duo). On l'exclut avant de construire les groupes de pastilles.
    const ordered = [...product.options]
      .filter((opt) => opt.name !== 'Title')
      .sort((a, b) => {
        const as = /size|taille/i.test(a.name) ? -1 : 0;
        const bs = /size|taille/i.test(b.name) ? -1 : 0;
        return as - bs;
      });

    ordered.forEach((opt) => {
      const realIndex = product.options.findIndex((o) => o.name === opt.name);
      const values = [...new Set(product.variants.map((v) => v[`option${realIndex + 1}`]))];

      const group = document.createElement('div');
      group.className = 'im-qv__opt-group';

      values.forEach((val) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'im-qv__opt-btn';
        btn.textContent = val;
        btn.dataset.optName = opt.name;
        btn.dataset.optIndex = String(realIndex);

        btn.addEventListener('click', () => {
          optBox.querySelectorAll(`.im-qv__opt-btn[data-opt-name="${CSS.escape(opt.name)}"]`)
            .forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          selections[opt.name] = val;
          setVariantBySelections();
        });

        group.appendChild(btn);
      });

      optBox.appendChild(group);
    });

    const v0 = product.variants.find((v) => v.available) || product.variants[0];
    product.options.forEach((opt, i) => (selections[opt.name] = v0[`option${i + 1}`]));

    Object.entries(selections).forEach(([name, val]) => {
      optBox.querySelectorAll(`.im-qv__opt-btn[data-opt-name="${CSS.escape(name)}"]`)
        .forEach((el) => { if (el.textContent === val) el.classList.add('is-active'); });
    });

    setVariantBySelections();
  };

  const renderProduct = (p) => {
    product = p;
    if (title) title.textContent = product.title;
    if (priceNode) priceNode.textContent = money(product.price || product.variants[0].price);
    if (liveCount) liveCount.textContent = String(getLiveCountForProduct(product));
    if (thumb) {
      thumb.innerHTML = (product.images && product.images.length)
        ? `<img src="${product.images[0]}" alt="${product.title}">`
        : '';
    }
    renderOptions();
    // Pas de flocage sur les vestes (type 'Veste') ni les produits tagués 'sans-flocage'.
    // Le Pack Duo (product_type vide côté admin) passait au travers de cette règle et
    // proposait à tort le flocage sur 2 vestes non flocables — bug confirmé le 15/09,
    // exclu ici par handle en plus du type (même pattern que im-cart.js / im-pack-duo.liquid).
    const noFloc = (p.type === 'Veste') || (p.handle === 'pack-duo-veste-bresil-coupe-vent') || (Array.isArray(p.tags) && p.tags.indexOf('sans-flocage') !== -1);
    const propsRow = root.querySelector('.im-qv__props');
    if (propsRow) {
      propsRow.hidden = noFloc;
      propsRow.style.display = noFloc ? 'none' : '';
    }
    if (noFloc && flocageToggle) flocageToggle.checked = false;
    updateFlocageVisibility();
  };

  // --- Flocage (stable)
  const updateFlocageVisibility = () => {
    if (!flocageToggle || !flocageFields) return;
    const on = !!flocageToggle.checked;

    // Montre/Cache
    flocageFields.hidden = !on;
    flocageFields.style.display = on ? 'block' : 'none';

    // Active/Désactive inputs SANS les vider (on ne touche pas à la valeur saisie)
    flocageFields.querySelectorAll('input,select,textarea,button').forEach((el) => {
      el.disabled = !on;
    });

    if (!on && numeroHint) numeroHint.textContent = '';
  };

  // Aperçu flocage LIVE (dos du maillot) — reflète Nom / Numéro / Sous le numéro
  const syncQvJersey = () => {
    if (qvJName)   qvJName.textContent = ((nomInput && nomInput.value) || '').toUpperCase().slice(0, 14) || 'GRINTA';
    if (qvJNumber) {
      const n = ((numeroInput && numeroInput.value) || '').replace(/[^\d]/g, '').slice(0, 4);
      qvJNumber.textContent = n || '10';
      qvJNumber.style.fontSize = (n.length > 2 ? 42 : 52) + 'px';
    }
    if (qvJSub) qvJSub.textContent = ((subInput && subInput.value) || '').toUpperCase().slice(0, 16);
  };

  // Numéro : seulement chiffres, max 4 (aligné sur la fiche produit) — validation douce
  const handleNumeroInput = () => {
    if (!numeroInput) return;
    const onlyDigits = numeroInput.value.replace(/[^\d]/g, '');
    if (onlyDigits !== numeroInput.value) {
      numeroInput.value = onlyDigits;
    }
    if (numeroInput.value.length > 4) {
      numeroInput.value = numeroInput.value.slice(0, 4);
    }
    if (numeroHint) numeroHint.textContent = '';
    syncQvJersey();
  };

  // Attacher 1 seule fois
  flocageToggle?.addEventListener('change', updateFlocageVisibility);
  numeroInput?.addEventListener('input', handleNumeroInput);
  nomInput?.addEventListener('input', syncQvJersey);
  subInput?.addEventListener('input', syncQvJersey);

  // Audit 27/10 (ACH5) : la touche « OK / Aller » du clavier dans le flocage envoyait le maillot au
  // panier sans numéro. Elle passe maintenant au champ suivant ; sur le dernier, elle ferme le clavier.
  const champsFloc = [nomInput, numeroInput, subInput].filter(Boolean);
  champsFloc.forEach((champ) => {
    champ.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
      e.preventDefault();
      const visibles = champsFloc.filter((x) => x.getClientRects().length > 0);
      const pos = visibles.indexOf(champ);
      if (pos > -1 && pos < visibles.length - 1) visibles[pos + 1].focus();
      else champ.blur();
    });
  });

  // --- Ajout panier
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!currentVariant) return;
    btnAdd.disabled = true;

    try {
      const fd = new FormData(form);
      // Ne jamais envoyer de propriétés de flocage VIDES (pollution des commandes /
      // Sheet fournisseur) — même comportement que la fiche produit.
      ['properties[Nom]', 'properties[Numéro]', 'properties[Sous le numéro]'].forEach((k) => {
        const v = (fd.get(k) || '').toString().trim();
        if (!v) fd.delete(k);
      });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) {
        let msg = 'Erreur ajout panier';
        try {
          const errData = await res.json();
          if (errData && (errData.description || errData.message)) {
            msg = errData.description || errData.message;
          }
        } catch (_) {}
        throw new Error(msg);
      }

      // Notify thème / cart drawer qu'un item a été ajouté
      document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      // Ferme la popup mobile
      close();

      // Ouvre le cart drawer via l'API IMCart (avec fallback)
      setTimeout(() => {
        if (window.IMCart && typeof window.IMCart.open === 'function') {
          window.IMCart.open();
        } else {
          const trigger = document.querySelector('[data-im-open-cart], [data-cart-trigger], .js-open-cart, [href="#cart-drawer"], .js-mini-cart');
          if (trigger) trigger.click();
        }
      }, 120);
    } catch (err) {
      console.error('[IM mobile popup] add-to-cart failed:', err);
      btnAdd.disabled = false;
      // Affiche le message d'erreur dans la popup (sans alert bloquant)
      const errBox = form.querySelector('[data-im-error]') || (() => {
        const el = document.createElement('div');
        el.setAttribute('data-im-error', '');
        el.style.cssText = 'color:#c33;font-size:13px;margin-top:8px;text-align:center;';
        form.appendChild(el);
        return el;
      })();
      errBox.textContent = err.message || 'Une erreur est survenue, réessayez.';
      setTimeout(() => { errBox.textContent = ''; }, 4000);
    }
  });

  // --- Ouverture QV
  window.addEventListener('im:qv:open', async (ev) => {
    if (isDesktop()) return;
    open(!!(ev && ev.detail && ev.detail.kb));

    // UI placeholders
    btnAdd.disabled = true;
    if (liveCount) liveCount.textContent = String(getLiveCountFromSeed(ev?.detail?.handle || 'default'));
    title.textContent = 'Chargement…';
    priceNode.textContent = '';
    thumb.innerHTML = '<div style="width:90px;height:90px;background:#f3f3f3;border-radius:14px;"></div>';
    optBox.innerHTML = '<div style="padding:12px 0;color:#999;text-align:center;">Préparation des tailles…</div>';
    if (sizeCurrent) sizeCurrent.textContent = '—';

    // Flocage OFF par défaut à l’ouverture
    if (flocageToggle) flocageToggle.checked = false;
    updateFlocageVisibility();
    // Row flocage masquée pendant le chargement (ré-affichée par renderProduct si le produit y a droit)
    const loadingPropsRow = root.querySelector('.im-qv__props');
    if (loadingPropsRow) { loadingPropsRow.hidden = true; loadingPropsRow.style.display = 'none'; }

    try {
      const p = await fetchProduct(ev.detail.handle);
      renderProduct(p);
      // Valide la disponibilité du variant courant
      btnAdd.disabled = !(currentVariant?.available ?? true);
    } catch (e) {
      console.error(e);
      title.textContent = 'Produit indisponible';
      btnAdd.disabled = true;
    }
  });

  // --- TRIGGER (bouton sur la carte produit)
  document.addEventListener('click', (e) => {
    if (isDesktop()) return;
    const btn = e.target.closest('.im-mpb, [data-im-qv-open]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    // 22/10 lot 3 : detail === 0 = bouton activé au clavier (Entrée/Espace) ; ≥ 1 = clic ou toucher
    window.dispatchEvent(new CustomEvent('im:qv:open', { detail: { handle, kb: e.detail === 0 } }));
  }, true);
})();

/* QV – cacher la bulle à l'ouverture, la remettre à la fermeture (robuste) */
(() => {
  const qv = document.getElementById('im-qv');
  if (!qv) return;

  // 1) Sélecteurs connus + fallback heuristique (bulle fixe en bas à droite)
  const KNOWN = [
    '.shopify-chat-bubble',
    '.gorgias-chat', '#gorgias-chat-container', 'iframe[src*="gorgias"]',
    '.tidio-chat', '#tidio-chat', 'iframe[src*="tidio"]',
    '.crisp-client', 'iframe[src*="crisp"]',
    '.intercom-lightweight-app', 'iframe[src*="intercom"]',
    '#tawkchat-minified', 'iframe[src*="tawk"]',
    '#hubspot-messages-iframe-container', 'iframe[id^="launcher"]'
  ];
  const FALLBACK_CANDIDATES = [
    'iframe[src*="chat"]',
    'iframe[id*="chat"]',
    '[id*="chat"]',
    '[class*="chat"]',
    '[id*="launcher"]',
    '[class*="launcher"]'
  ].join(',');

  const saved = new WeakMap();

  const collectWidgets = () => {
    const set = new Set();
    KNOWN.forEach(s => document.querySelectorAll(s).forEach(el => set.add(el)));

    // Fallback limité: on évite un scan complet de tout le DOM.
    document.querySelectorAll(FALLBACK_CANDIDATES).forEach(el => {
      if (!(el instanceof HTMLElement) || qv.contains(el)) return;
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      const nearBR = (innerWidth - r.right < 180) && (innerHeight - r.bottom < 180);
      const small  = r.width <= 360 && r.height <= 360;
      const zi     = parseInt(cs.zIndex || '0', 10);
      if ((nearBR && small && zi > 1000) || (el.tagName === 'IFRAME' && zi > 1000)) set.add(el);
    });

    return [...set];
  };

  const hide = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) saved.set(el, el.getAttribute('style') || '');
      el.style.cssText += ';opacity:0!important;visibility:hidden!important;pointer-events:none!important;';
    });
  };

  const show = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) return;
      const s = saved.get(el);
      s ? el.setAttribute('style', s) : el.removeAttribute('style');
      saved.delete(el);
    });
  };

  const isOpen = () => {
    const cs = getComputedStyle(qv);
    return qv.classList.contains('is-open') ||
           qv.getAttribute('aria-hidden') === 'false' ||
           cs.display !== 'none';
  };

  const sync = () => (isOpen() ? hide() : show());
  let syncTimer = null;
  const scheduleSync = (delay = 80) => {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay);
  };

  // 2) Réagit aux changements d’état (open/close)
  new MutationObserver(() => scheduleSync(0)).observe(qv, {
    attributes: true,
    attributeFilter: ['class','style','aria-hidden']
  });
  new MutationObserver(() => scheduleSync(120)).observe(document.body, {
    childList: true,
    subtree: true
  });

  // 3) Hooks explicites : ton code déclenche déjà im:qv:open ; on écoute aussi la fermeture
  window.addEventListener('im:qv:open', () => scheduleSync(0));
  document.addEventListener('click', e => {
    if (e.target.closest('[data-im-qv-close]') || e.target.closest('.im-qv__scrim, .im-qv__backdrop')) {
      scheduleSync(0);
    }
  }, true);

  // 4) Premier passage
  sync();
})();
